'use strict';

module.exports = {
  UC_BROWSER: 'UC_BROWSER',
  UC_BROWSER_INTL: 'UC_BROWSER_INTL',
  UC_NEWS: 'UC_NEWS',
  UC_NEWS_INTL: 'UC_NEWS_INTL',
  COMMON: 'COMMON', // 业务自行传入
  UC_LITE: 'UC_LITE'
};